import React, { type FC, type PropsWithChildren } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import { Loading, ToastContainer } from 'mailup-web-components'

import ErrorFeedback from 'Components/ErrorFeedback'
import PageContainer from 'Components/PageContainer'
import { pageState } from 'State/page'



type PageProps = PropsWithChildren<{
  className?: string
  onReload: () => void | Promise<void>
}>

const Page: FC<PageProps> = ({ children, className, onReload }) => {
  const { status, loading, errorMessage } = useRecoilValue(pageState)
  const intl = useIntl()

  return (
    <>
      <Loading open={loading} />
      <ToastContainer />

      <PageContainer className={className}>
        {status === 'error' ? (
          <ErrorFeedback
            error={
              errorMessage ??
              intl.formatMessage({ id: 'Load.Alerts.ErrorGeneric' })
            }
            severity='danger'
            onClickReload={onReload}
          />
        ) : status === 'ready' ? (
          children
        ) : null}
      </PageContainer>
    </>
  )
}

export default Page
